// --- API --- //

export const API_BASE = "https://shipowners-api.nextship.net/"

export const API_VERSION = 'api/v1/'

export const CLIENT_ID = 'Wgab4EDD9RvQhJ8FsWcDrjv6ViLIRPXF4CDM4HYN'
export const CLIENT_SECRET = `Pc1RrwJJlgm4JSASjR0H9rkNDXfOTgEdK7Y0zYcMMUTzbfg9bOl5C3Q2a5wFofkQ5AOAUkjPh8lgEQloOkvd5GLlzoygaqG5fmNdZhmKDRTOUpkBdcIqiCvVa4moBFRO`
